export function getScrollParents(el: HTMLElement | null): HTMLElement[] {
  const parents: HTMLElement[] = [];
  let node = el?.parentElement;
  while (node) {
    const { overflow, overflowY, overflowX } = getComputedStyle(node);
    if (/auto|scroll/.test(overflow + overflowY + overflowX)) {
      parents.push(node);
    }
    node = node.parentElement;
  }
  return parents;
}
